<template>
  <div class="epayTradeDetail-details">
    <div class="breadcrumb" style="background: #fff">余额交易明细</div>
    <div class="order-detail-basic">
      <el-form label-width="10em">
        <el-form-item v-for="(v, k) in filterTrade" :key='k' :label="label[k]">{{ v }}</el-form-item>
      </el-form>
    </div>
    <div class="edit-button">
      <el-button type="primary" round style="width: 100px;margin-left: 20px;" @click="applyRefundDialog = true">申请退款</el-button>
      <el-button round type="primary" @click="returnPage">返回</el-button>
    </div>
    <el-dialog :close-on-click-modal="false" title="申请退款" :visible.sync="applyRefundDialog" width="30%">
      <div class="order-detail-basic">
        <el-form :model="applyRefundForm" label-width="140px" class="demo-ruleForm">
          <el-form-item label="当前余额:"> {{ this.accountInfo.balanceMap.VPAY_ACCOUNT.balance }} </el-form-item>
          <el-form-item label="当前虚拟余额:"> {{ this.accountInfo.balanceMap.VPAY_BONUS.balance }} </el-form-item>
          <el-form-item label="充值金额:"> {{ this.trade.amount }} </el-form-item>
          <el-form-item label="退款金额:">
            <el-input v-model.number="submitForm.amount" clearable></el-input>
          </el-form-item>
          <el-form-item label="清空的虚拟余额额度:">
            <el-input v-model.number="submitForm.bonus" clearable></el-input>
          </el-form-item>
          <el-form-item label="备注:">
            <el-input v-model="submitForm.remark" clearable></el-input>
          </el-form-item>
          <div class="edit-button">
            <el-button type="primary" round style="width: 100px;margin-left: 20px;" @click="applyRefundDialog = false">取消</el-button>
            <el-button round type="primary" @click="submitApply">确定</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// "id", "outOrderNo","tradeNo", "amount", "paymentType", "paymentStatus", "paymentDate",  "tradeMethod", "tradeType", "payments"
import { handleCashout, tradeGet, applyOnline, accountGetByStoreId } from '@/api/epay'
export default {
  name: 'EpayTradeDetail',
  data () {
    return {
      applyRefundDialog: false,
      applyRefund: {},
      accountInfo: {
        balanceMap: {

        },
        store: {

        }
      },
      submitForm: {
        amount: '',
        bonus: '',
        orderNo: '',
        remark: ''
      },
      label: {
        id: 'ID',
        outOrderNo: '订单号',
        tradeNo: '流水号',
        amount: '支付金额',
        bonus: '支付虚拟充值',
        tradeType: '交易类型',
        tradeMethod: '交易方式',
        paymentType: '支付类型',
        paymentStatus: '支付状态',
        paymentDate: '支付日期'
      },
      trade: {}
    }
  },
  created () {
    this.init()
    // accountGetByStoreId(this.trade.store.id).then((res) => {
    //   if (res.data.success) {
    //     let obj = {}
    //     obj = res.data.data
    //     obj.sendFlag = obj.sendFlag === undefined ? '1' : obj.sendFlag
    //     if (!obj.address) {
    //       obj.address = {}
    //     }
    //     if (res.data.data.storeTypeBean === undefined) {
    //       obj.storeTypeBean = {
    //         id: ''
    //       }
    //     }
    //     this.accountInfo = obj
    //   }
    // })
  },
  computed: {
    filterTrade: function () {
      let _trade = {}
      Object.keys(this.label).forEach(key => {
        let val = this.trade[key]
        val = this.$config[key] ? this.$config[key][val] : val// ?
        _trade[key] = val
      })
      return _trade
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  methods: {
    init () {
      tradeGet(this.$route.query.id).then(res => {
        this.trade = res.data.data
        this.accountDateInfo(this.trade.store.id)
      })
    },
    returnPage () {
      if (window.history.length <= 1) {
        this.$router.push({ path: '/home' })
        return false
      } else {
        this.$router.go(-1)
      }
    },
    submitApply () {
      this.submitForm.orderNo = this.trade.outOrderNo
      applyOnline(this.submitForm).then(res => {
        if (res.data.success) {
          this.$message.success('申请成功')
          if (this.checkType) {
            this.storeMsg = res.data.data
            this.checkTrueDialog = true
          } else {
            this.checkDialog = false
            this.$router.go(-1)
          }
        }
      })
    },
    accountDateInfo (storeId) {
      console.log(storeId)
      accountGetByStoreId(storeId).then((res) => {
        if (res.data.success) {
          let obj = {}
          obj = res.data.data
          obj.sendFlag = obj.sendFlag === undefined ? '1' : obj.sendFlag
          if (!obj.address) {
            obj.address = {}
          }
          if (res.data.data.storeTypeBean === undefined) {
            obj.storeTypeBean = {
              id: ''
            }
          }
          this.accountInfo = obj
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
.recharge-details {
  .el-input {
    @{deep} .el-input__inner {
      //color: #F56C6C;
      -moz-appearance: textfield;
    }

    @{deep} .el-input__inner::-webkit-inner-spin-button,
    @{deep} .el-input__inner::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
}

@deep: ~">>>";
</style>
